// @ts-nocheck
import React from 'react';
import { Button } from 'antd';
import { pddTest } from '../../../../../lib/enum';
import { navigate } from '../../../../../lib/helpers';
import { ReloginButton } from './index';
export default ({
  examTraining,
  canStartTest,
  canRelogin
}) => <>
    {examTraining === pddTest.training && canStartTest && <>
        <Button type="primary" onClick={() => navigate('/pdd/test/training/test-exam/')}>
          Тренировочное тестирование
        </Button>
      </>}
    {examTraining === pddTest.exam && canStartTest && <>
        <Button type="primary" onClick={() => navigate('/pdd/test/exam/exam/0')}>
          Начать экзамен
        </Button>
      </>}
    {canRelogin && <ReloginButton />}
  </>;
